<template>
  <div>
    <template v-for="(questionTemplate, index) in dataSource.questionTemplateData">
      <v-layout row wrap :key="assist.tool.getRandomKey(index)">
        <v-flex lg12>
          <h5>
            <v-icon>keyboard_arrow_right</v-icon>
            {{ questionTemplate.question }}
          </h5>
        </v-flex>
      </v-layout>
      <v-layout :key="assist.tool.getRandomKey(index)">
        <v-flex lg1></v-flex>
        <v-flex>
          <v-radio-group
            row
            v-if="assist.tool.isNotEmpty(current.questionAnswerData)"
            v-model="current.questionAnswerData[questionTemplate.id].value"
          ><v-radio
            v-for="(option, j) in JSON.parse(questionTemplate.options)"
            color="primary"
            :label="option.text"
            :value="option.value"
            :key="assist.tool.getRandomKey(j)"
          ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { DataType, Tool } from '@/util/index'
const TOOL = new Tool()
export default {
  name: 'application-detail-dialog',
  props: {
    layoutSetting: Object,
    current: Object,
    dataSource: Object
  },
  data () {
    return {
      assist: {
        tool: TOOL,
        dataType: DataType
      }
    }
  }
}
</script>
